import React from 'react'
import { connect } from 'react-redux';
import { localization } from '../../../../Utils/Localization/localization';
import { languageSelector } from '../../../../Redux/Reducers/settingsReducer';
import { userLevelSelector } from '../../../../Redux/Reducers/userReducer';
import classes from './ProductsPage.module.scss';
import {
  Select,
  Button,
  Empty,
  Modal
} from 'antd';
import {
  IPagination,
  IProductFull
} from '../../../../Utils/types';
import {
  productsSelector,
  productsStatusSelector,
  getProducts,
  removeProduct
} from '../../../../Redux/Reducers/productsReducer';
import {
  paginationInfoSelector
} from '../../../../Redux/Reducers/paginationReducer';
import { ProductDrawer } from '../../../ProductDrawer/ProductDrawer';
import { Pagination } from '../../../Pagination/Pagination';

interface StateProps {
  language: string,
  paginationInfo: IPagination,
  products: IProductFull[],
  productsStatus: 'loaded' | 'loading',
  level: number
}
interface DispatchProps {
  getProducts: (page: number, pageSize: number) => void,
  removeProduct: (id: number) => void
}
interface Props extends StateProps, DispatchProps { }

function ProductsPage(props: Props) {
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(10);
  const [currentProduct, setCurrentProduct] = React.useState(0);
  const permissionLevel = props.level >= 2;

  React.useEffect(() => {
    handleGetProducts();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize]);

  function handleGetProducts() {
    props.getProducts(page, pageSize);
  }

  function applyFilters(size: number) {
    setPageSize(size);
  }

  function handleRemove(id: number) {
    Modal.confirm({
      okText: localization('delete', props.language),
      okCancel: localization('cancel', props.language),
      title: localization('deleteProductDescription', props.language),
      onOk() {
        props.removeProduct(id);
      }
    });
  }

  function handleEdit(id: number) {
    setCurrentProduct(id);
  }

  function handleOnCloseDrawer() {
    setCurrentProduct(0);
  }

  return (
    <div className={classes.ProductsPage}>
      <ProductDrawer
        id={currentProduct}
        visible={currentProduct !== 0}
        onClose={handleOnCloseDrawer}
      />
      <h2>{localization('allProducts', props.language)}</h2>
      <div className={classes.Filters}>
        <Select defaultValue={pageSize} onChange={(e: any) => { applyFilters(e); }}>
          <Select.Option value={10}>10</Select.Option>
          <Select.Option value={25}>25</Select.Option>
          <Select.Option value={50}>50</Select.Option>
        </Select>
        <Button
          onClick={handleGetProducts}
          loading={props.productsStatus === 'loading'}
        >
          {localization('refresh', props.language)}
        </Button>
      </div>
      <ul className={classes.ProductsList}>
        {
          props.productsStatus === 'loading'
            ? <span>{localization('wait', props.language)}</span>
            : props.products.length > 0
              ? props.products.map((item) => {
                return (
                  <li className={classes.Product} key={item.id}>
                    <div>
                      <img src={item.photourl.huge} alt="Product" />
                    </div>
                    <div>
                      <span>{item.name}</span>
                    </div>
                    <div>
                      <span>{item.price} RUB</span>
                    </div>
                    <div className={classes.Btns}>
                      <Button
                        onClick={() => { handleEdit(item.id) }}
                      >
                        {
                          permissionLevel
                            ? localization('edit', props.language)
                            : localization('view', props.language)
                        }
                      </Button>
                      <Button
                        type={'danger'}
                        onClick={() => { handleRemove(item.id) }}
                      >
                        {localization('delete', props.language)}
                      </Button>
                    </div>
                  </li>
                );
              })
              : <Empty description={localization('noItems', props.language)} />
        }
        <Pagination
          handleChangePage={(value: number) => setPage(value)}
          paginationInfo={props.paginationInfo}
        />
      </ul>
    </div>
  );
}

function mapStateToProps(state: any) {
  return {
    language: languageSelector(state),
    paginationInfo: paginationInfoSelector(state),
    products: productsSelector(state),
    productsStatus: productsStatusSelector(state),
    level: userLevelSelector(state)
  }
}
const mapDispatchToProps = {
  getProducts,
  removeProduct
}

const ConnectedProductsPage = connect(mapStateToProps, mapDispatchToProps)(ProductsPage);
export { ConnectedProductsPage as ProductsPage };